import React, { useEffect, useMemo, useState } from 'react';
import Element from './Element';
import cx from '@utils/cx.util';

type SectionProps = {
  type?: string;
  position: string;
  debug: boolean;
  components: any;
  elements: any;
};

const FULL_WIDTH_ELEMENTS = ['findYourFit'];

const Section = ({ position, debug = false, ...props }: SectionProps) => {
  if (debug) {
    return (
      <div className='tw-relative -tw-mx-2 tw-my-6 tw-min-h-[40px] tw-rounded tw-border-2 tw-border-dotted tw-border-neutrals-light-grey tw-py-4'>
        <div className='tw-absolute -tw-top-3 tw-w-full tw-text-center'>
          <div className='tw-mx-auto tw-inline-block tw-w-[12rem] tw-border tw-border-neutrals-light-grey tw-bg-white tw-p-1 tw-text-center tw-text-xs'>
            {position}:BEGIN
          </div>
        </div>
        <div className='tw-absolute -tw-bottom-3 tw-w-full tw-text-center'>
          <div className='tw-mx-auto tw-inline-block tw-w-[12rem] tw-border tw-border-neutrals-light-grey tw-bg-white tw-p-1 tw-text-center tw-text-xs'>
            {position}:END
          </div>
        </div>
        <SectionImpl {...{ position, debug }} {...props} />
      </div>
    );
  } else {
    return <SectionImpl {...{ position, debug }} {...props} />;
  }
};

const SectionImpl = ({
  type = null,
  position,
  components: allComponents,
  elements: allElements,
  debug = false,
}) => {
  // console.log({ allElements });

  const components = useMemo(() => {
    return (
      allComponents &&
      allComponents.reduce((a, c) => {
        if (c.position === position) {
          a.push(c);
        }
        return a;
      }, [])
    );
  }, [allComponents]);

  const elements = useMemo(() => {
    return (
      allElements &&
      allElements.reduce((a, c) => {
        if ((c.position ?? 'after_item') === position) {
          a.push(c);
        }
        return a;
      }, [])
    );
  }, [allElements]);

  if (!elements?.length) return null;

  const Wrapper = type === 'page' ? PageWrapper : React.Fragment;

  return (
    <>
      {elements.map((e, i) => {
        const wrapperProps =
          Wrapper !== React.Fragment ? { fullWidth: FULL_WIDTH_ELEMENTS.includes(e.elementType) } : {};

        return (
          <Wrapper key={i} {...wrapperProps}>
            <Element {...e} />
          </Wrapper>
        );
      })}
    </>
  );
};

const PageWrapper = ({ children, fullWidth = false }) => {
  // console.log('PageWrapper', { children, fullWidth });

  return (
    <div
      className={cx('tw-relative tw-mx-auto tw-w-full tw-px-4 tw-text-center', {
        'tw-max-w-[1480px]': !fullWidth,
      })}>
      {children}
    </div>
  );
};

export default Section;
